import * as React from "react";
import type { SVGProps } from "react";
const SvgCancelRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeWidth={2}
      d="m8.4 15.6 7.2-7.2M12 21.6a9.6 9.6 0 1 1 0-19.2 9.6 9.6 0 0 1 0 19.2Z"
      opacity={0.9}
    />
  </svg>
);
export default SvgCancelRight;
